module.exports = __webpack_public_path__ + "img/ico_9.32ec9d8a.png";